import { useQuery } from '@tanstack/react-query';

import { callGetRecentEmojis } from '@app/client/resources/emojis/emojis';

export const useRecentYatsQuery = () => {
    return useQuery({
        queryKey: ['RecentYats'],
        queryFn: () =>
            callGetRecentEmojis({}).then((r) => {
                if (r.ok && r.value) {
                    return r.value;
                }
            }),
        retry: false,
    });
};
